import React from 'react';
import _ from 'lodash';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { WidgetTypeEnum } from '@/types/schema';

import EmptyStateStackItem from './EmptyStateStackItem';

export const geti18nKey = (widgetType: WidgetTypeEnum): string => {
  const widgetTypeKey = _.upperFirst(_.camelCase(widgetType));
  return `Home:EmptyState.${widgetTypeKey}`;
};

const StackEmptyState = ({
  has2Columns,
  widgetType,
  transparentBackground,
}: {
  has2Columns: boolean;
  widgetType: WidgetTypeEnum;
  transparentBackground?: boolean;
}) => {
  const i18nKey = geti18nKey(widgetType);
  const { t } = useTranslation();

  return (
    <Stack className="h-full relative">
      <Stack
        alignItems="stretch"
        className={cn('w-full h-full', has2Columns ? 'grid grid-cols-2' : '')}
        direction="row"
        gapX={20}
        gapY={12}
        justifyContent="start">
        <Stack
          alignItems="center"
          className={cn('w-full h-full', has2Columns ? 'col-span-1' : '')}
          direction="col"
          gap={12}>
          <EmptyStateStackItem></EmptyStateStackItem>
        </Stack>
        {has2Columns ? (
          <Stack
            alignItems="center"
            className={cn('w-full h-full', has2Columns ? 'col-span-1' : '')}
            direction="col"
            gap={12}>
            <EmptyStateStackItem></EmptyStateStackItem>
          </Stack>
        ) : null}
      </Stack>
      <Stack
        className={cn(
          'w-[200px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
          transparentBackground ? '!bg-bg-transparent' : 'bg-bg-primary ',
        )}>
        <Typography
          className={cn(
            'text-text-placeholder text-center',
            transparentBackground ? '!bg-bg-transparent' : '',
          )}
          variant="label-02">
          {t(i18nKey)}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default StackEmptyState;
